import Chevron from 'components/Icons/ChevronDirectional';
import MapIconButton from 'components/MapIconButton';
import { Direction, Directions } from 'constants/directions';
import React from 'react';

type Props = {
  direction: Direction;
  onClick: () => void;
};

const directionStyles = {
  [Directions.UP]: {
    gridRow: 1,
    gridColumn: 2,
    borderRadius: '3px 3px 0 0',
  },
  [Directions.DOWN]: {
    gridRow: 3,
    gridColumn: 2,
    borderRadius: '0 0 3px 3px',
  },
  [Directions.LEFT]: {
    gridRow: 2,
    gridColumn: 1,
    borderRadius: '3px 0 0 3px',
  },
  [Directions.RIGHT]: {
    gridRow: 2,
    gridColumn: 3,
    borderRadius: '0 3px 3px 0',
  },
};

const DirectionalButton: React.FC<Props> = ({ direction, onClick }: Props) => {
  return (
    <MapIconButton onClick={onClick} styles={directionStyles[direction]}>
      <Chevron direction={direction} />
    </MapIconButton>
  );
};

export default DirectionalButton;
